import request from '@/utils/request'

export function fetchCashAccList(params) {
  return request({
    url:'cashAccount/list/',
    method:'get',
    params:params
  })
}

export function fetchCashAccHistoryList(params,id) {
  return request({
    url:'/cashAccount/history/'+ id,
    method:'get',
    params:params
  })
}


export function createCashAcc(data) {
  return request({
    url:'/cashAccount/create',
    method:'post',
    data:data
  })
}

export function updateCashAcc(id, data) {
  return request({
    url:'/cashAccount/update/' + id,
    method:'post',
    data:data
  })
}

export function updateCrudStatus(id,params) {
  return request({
    url:'/cashAccount/updateCrudStatus/'+ id,
    method:'post',
    params: params
  })
}

